import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Cloud, XCircle, ArrowRight } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 py-4">
        <div className="max-w-7xl mx-auto px-6">
          <Link to="/" className="flex items-center gap-2">
            <Cloud className="w-8 h-8 text-bronze" />
            <span className="text-xl font-bold text-midnight font-outfit">CloudSync Pro</span>
          </Link>
        </div>
      </header>

      <div className="max-w-md mx-auto px-6 py-16">
        <Card className="shadow-elevated" data-testid="cancel-card">
          <CardContent className="pt-12 pb-8 text-center">
            <div className="w-20 h-20 mx-auto bg-slate-100 rounded-full flex items-center justify-center mb-6">
              <XCircle className="w-10 h-10 text-slate-400" />
            </div>
            <h1 className="text-2xl font-bold text-midnight mb-2 font-outfit">
              Payment Cancelled
            </h1>
            <p className="text-slate-600 mb-8">
              No worries! Your payment was not processed. You can try again whenever you're ready.
            </p>
            
            <div className="space-y-3">
              <Link to="/">
                <Button className="w-full bg-midnight hover:bg-slate-800 text-white rounded-full py-6">
                  Try Again
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
              <Link to="/">
                <Button variant="ghost" className="w-full text-slate-600">
                  Return to Home
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-sm text-slate-500 mt-8">
          Have questions? <a href="#" className="text-bronze hover:underline">Contact our support team</a>
        </p>
      </div>
    </div>
  );
}
